import { useEffect, useRef } from 'react';

export function useFocusTrap(active = true) {
    const elementRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (!active) return;

        const element = elementRef.current;
        if (!element) return;

        // Get all focusable elements
        const focusableElements = element.querySelectorAll<HTMLElement>(
            'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
        );

        const firstFocusableElement = focusableElements[0];
        const lastFocusableElement = focusableElements[focusableElements.length - 1];

        function handleKeyDown(e: KeyboardEvent) {
            if (e.key !== 'Tab') return;

            if (e.shiftKey) {
                // If shift + tab pressed
                if (document.activeElement === firstFocusableElement) {
                    lastFocusableElement.focus();
                    e.preventDefault();
                }
            } else {
                // If tab pressed
                if (document.activeElement === lastFocusableElement) {
                    firstFocusableElement.focus();
                    e.preventDefault();
                }
            }
        }

        element.addEventListener('keydown', handleKeyDown);
        firstFocusableElement.focus();

        return () => {
            element.removeEventListener('keydown', handleKeyDown);
        };
    }, [active]);

    return elementRef;
}